module.exports = __webpack_public_path__ + "static/media/Delcatty_gaussian2.de34293a.png";